import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';
import { ClientService } from '../services/client.service';
import { User } from '../shared/models/user.model';
import { Client } from '../shared/models/client.model';
import { ToastComponent } from '../shared/toast/toast.component';
import { ee, departments, dateRegexp, perPage100, jobs, sites } from '../shared/constants';
import { saveFile } from '../shared/functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss'],
  standalone: false
})
export class TeamComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  private userService = inject(UserService);
  private clientService = inject(ClientService);
  toast = inject(ToastComponent);


  isLoading = {
    team: true,
    stats: true,
  };
  isSearching = false;
  departments = departments;
  jobs = jobs;
  sites = sites;
  dateRegexp = dateRegexp;
  perPage = perPage100;
  page = 0;
  count = 0;
  canExportCsv = false;
  // Filters
  lastName = '';
  department = '';
  job = '';
  site = '';
  client = '';
  disabled = '0';
  // Arrays
  team: User[];
  clients: Client[] = [];
  currentContent = 'team';
  menuItems = [
    { name: 'Team', link: 'team', icon: 'heart' },
  ];

  ngOnInit(): void {
    ee.on('changeContent', (data: string) => this.currentContent = data);
    ee.on('getUsers', (page?: number) => this.search(page));
    this.canExportCsv = this.auth.currentUser.permissions.includes('exportCsv');
    this.getClients();
    this.search();
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
  }

  getClients(): void {
    this.clientService.search({ active: '1' })
      .subscribe({
        next: res => this.clients = res.results,
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

  search(page?: number, csv?: boolean): void {
    this.isLoading.team = true;
    this.isSearching = true;
    this.page = page || 0;
    const params = {
      lastName: this.lastName,
      department: this.department,
      job: this.job,
      site: this.site,
      disabled: this.disabled,
      csv: csv || false,
      page: this.page,
      perPage: this.perPage,
    };
    this.userService.search(params)
      .pipe(finalize(() => this.isLoading.team = false))
      .subscribe({
        next: res => {
          if (csv) {
            saveFile(res, 'team.csv');
          } else {
            this.team = res.results;
            this.count = res.count;
          }
        },
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
